import { Button, Plus } from '@core/ui';
import { useTranslation } from 'react-i18next';
import { AddChapterButtonProps } from './types';

export const AddChapterButton = ({ onClick, ...props }: AddChapterButtonProps) => {
    const { t } = useTranslation();

    return (
        <Button type={'button'} variant="primary" classNames="mt-2 ml-10" onClick={onClick} data-testid="addChapter" {...props}>
            <Plus classNames="flex-none size-5 mr-2 stroke-current" data-testid="addButton" />
            <span data-testid="addButton">{t('Content.Chapters.Button.AddChapter')}</span>
        </Button>
    );
};
